export const veridionPageUK = {
  "seo": {
    "title": "Veridion Agentic Company Intelligence | Організація зі співробітників-ШІ",
    "description": "Наступний щабель продуктивності: Organisation as a Service. Організація зі співробітників-ШІ постачає перевірену роботу, планує у фіксованих циклах і працює локально або у вашій хмарі."
  },
  "hero": {
    "kicker": "Veridion Agentic Company Intelligence",
    "title": "Один творець, нескінченна кількість рішень.",
    "claim": "Наступний щабель продуктивності: Organisation as a Service.",
    "lead": "Корпоративний ШІ, що керує всією pAIoneer Labs GmbH: ШІ-колектив, який інтегрується в кожний процес вашої компанії, самостійно доводить роботу до кінця й навчається з кожним завданням. Люди задають напрям. Усе інше відбувається саме собою."
  },
  "vision": {
    "lines": [
      "Програмне забезпечення дало компаніям інструменти.",
      "ШІ дав їм асистентів.",
      "Veridion дає їм організацію."
    ],
    "note": "Інформація рухається за години, досвід виходить на пенсію, посади лишаються незаповненими. Ще один інструмент цього не розв’язує; розв’язує колектив, якого не треба наймати."
  },
  "grow": {
    "title": "Чого не вміє, те створює",
    "text": "Там, де для завдання ще не існує потрібної здатності або щось неможливо вирішити наявними засобами, Veridion самостійно розробляє нові, довільно складні ШІ-системи — ШІ сам розвиває ШІ далі: проєктує, будує, перевіряє та вводить у дію. Лише затвердження залишається за людиною через [Intent-Driven Development](idd) (IDD).",
    "punch": "Саме це й означає: один творець, нескінченна кількість рішень."
  },
  "integrate": {
    "title": "У самій серцевині ваших процесів",
    "subtitle": "Жодного нового програмного забезпечення, жодного навчання, жодної міграції.",
    "cards": [
      {
        "title": "У корпоративному чаті",
        "text": "Розмова відбувається там, де ваші люди й так пишуть: Webex, Microsoft Teams, Zoom, Slack. Достатньо одного повідомлення."
      },
      {
        "title": "У ваших інструментах",
        "text": "Управління проєктами, репозиторії, сховища документів: робота відбувається в системах, які вже є, а не повз них."
      },
      {
        "title": "Від пропозиції до бухгалтерії",
        "text": "Один процес за іншим, у вашому темпі. Коли потужностей бракує — також лише окремий пакет розробки або цілий проєкт."
      }
    ]
  },
  "org": {
    "title": "Колектив, організований як компанія",
    "subtitle": "Ми не нав’язуємо жодній компанії жорсткий шаблон: для будь-якої структури підприємства ми створюємо індивідуальну органіграму, визначаємо чіткі ролі та зони відповідальності й гнучко адаптуємося. Кожен бізнес-підрозділ складається зі ШІ-співробітників, яких оркеструє Veridion і які працюють повністю автоматизовано аж до [IDD](idd)-Human-in-the-Loop — а якщо щось ще неможливо, Veridion сам розробляє новий ШІ.",
    "execKicker": "Координаційний рівень — повністю автоматизовано до IDD Human-in-the-Loop",
    "execTitle": "Індивідуальна органіграма, чіткі ролі та ШІ, що сам розвиває ШІ далі.",
    "execText": "Під керівництвом людей координаційний рівень і бізнес-підрозділи зі ШІ-співробітників працюють повністю автоматизовано: вони декомпозують цілі, розподіляють роботу за чітко визначеними ролями та обов’язками, самостійно вирішують проблеми й запитують цільові погодження від людини. Людина в контурі керує через [Intent-Driven Development](idd) (IDD) — далеко за межами програмного коду як спільне управління людини та ШІ через наміри, рішення та сценарії перевірки. І щоразу, коли певної здатності бракує, Veridion самостійно проєктує та створює нові, довільно складні ШІ-системи — ШІ розвиває ШІ далі.",
    "units": [
      {
        "name": "Розробка програмного забезпечення",
        "text": "Відповідає за програмне забезпечення від вимоги до експлуатації: архітектура, код, тести, рев’ю, конвеєри та якість, що за ними стоїть."
      },
      {
        "name": "Електроніка та вбудоване ПЗ",
        "text": "Відповідає за апаратний бік: схеми, вбудоване ПЗ та вибір кожного компонента."
      },
      {
        "name": "Квантові обчислення та квантовий ШІ",
        "text": "Відповідає за дослідження квантових обчислень і квантового ШІ та перетворює надійні результати на продукти."
      },
      {
        "name": "Продажі та маркетинг",
        "text": "Відповідає за ринок: спостерігає за ним, знаходить цільових клієнтів, створює досьє, готує тексти та пропозиції. Угоду укладає людина."
      },
      {
        "name": "Продукти та експлуатація платформи",
        "text": "Відповідає за продукти та експлуатацію: стратегія, пріоритети, релізи, а також моніторинг, інциденти та потужність робочої платформи."
      },
      {
        "name": "Адміністрування та фінанси",
        "text": "Відповідає за комерційну частину: первинні документи, рахунки, договори, строки, підготовлені аж до підпису, і він лишається за вами."
      }
    ]
  },
  "trust": {
    "title": "На що ви можете покластися",
    "cards": [
      {
        "title": "Human-in-the-Loop та IDD далеко за межами коду",
        "text": "Intent-Driven Development ([IDD](idd)) виходить далеко за межі написання коду: це те, що людина в контурі робить разом із ШІ в усіх сферах компанії. Людина та ШІ спільно формулюють намір (Intent), ухвалюють обов’язкові рішення (Decisions) і визначають перевірювані сценарії (Scenarios), перш ніж штат ШІ-співробітників самостійно виконує роботу у фіксованих прогнозованих циклах, а людина надає цільове підтвердження."
      },
      {
        "title": "Комунікація, оптимізована теорією ігор",
        "text": "Управління проєктами та комунікація співробітників-ШІ оптимізовані теорією ігор, від окремого ШІ-співробітника до цілого бізнес-підрозділу: ретельність і обґрунтоване заперечення приносять виграш; формальне схвалення, повторення та перекидання відповідальності обходяться дорого. Так перемагає найкраща комунікація."
      },
      {
        "title": "Пояснюваність аж до джерела",
        "text": "Explainable AI тут — робочий принцип, а не доповнення: кожний результат розкриває, з чого він постав, — знайдені місця в корпоративних знаннях, дані, хід обчислень. Що не має підтвердження, те не стверджується."
      },
      {
        "title": "Вчиться самостійно",
        "text": "Після кожного проходу зчитуються власні показники, і за ними коригуються власні правила: кожний поточний проєкт робить ціле кращим."
      }
    ]
  },
  "daily": {
    "title": "Що вже сьогодні беруть на себе",
    "subtitle": "Щодня, через усю компанію.",
    "items": [
      {
        "title": "Розробка",
        "text": "Код, тести й документація із зафіксованих рішень. Модернізація успадкованого програмного забезпечення з доказами golden master і back-to-back."
      },
      {
        "title": "Електроніка та вбудоване ПЗ",
        "text": "Аналізувати технічні описи, симулювати схеми як цифрові двійники, розробляти вбудоване ПЗ й оцінювати альтернативи компонентів, перш ніж щось буде виготовлено, близько до апаратного забезпечення — аж до сенсора."
      },
      {
        "title": "Квантові дослідження",
        "text": "Вивчати сучасний стан галузі, будувати й оцінювати відтворювані експерименти проти класичних порівняльних баз, кожний результат зафіксовано так, що його можна простежити."
      },
      {
        "title": "Аналіз даних",
        "text": "SQL Server, MariaDB, MySQL та Oracle: типізований план аналізу, виключно запити на читання, статистика із середовища виконання, звіти з одного версіонованого результату."
      },
      {
        "title": "Адміністрування та фінанси",
        "text": "Бухгалтерія, фінансовий облік і бюрократія, яку приносить із собою товариство: читати, розподіляти й архівувати первинні документи; чернетки для рахунків і договорів — у комплекті."
      },
      {
        "title": "Проєкти та завдання",
        "text": "Стенограма зустрічі без обхідних шляхів стає завданнями в управлінні проєктами, а поступ повертається: наступна зустріч починається з актуального стану."
      },
      {
        "title": "Корпоративні знання",
        "text": "База знань для документів і графова база даних, що пов’язує завдання, рішення, людей і системи: зв’язок упродовж тижнів і поза межами проєктів."
      },
      {
        "title": "Дослідження в інтернеті",
        "text": "Чого немає в корпоративних знаннях, те досліджується: пошук, читання найкращих сторінок, і наприкінці — звіт, у якому кожне твердження має своє пронумероване джерело."
      },
      {
        "title": "Голос і зустрічі",
        "text": "Усією компанією можна керувати на ходу: усні розмови виконують ті самі завдання, що й чат, також у дорозі з телефона."
      },
      {
        "title": "Офісна робота з RoBuddy",
        "text": "RoBuddy покриває робоче місце: зустрічі, електронні листи, навчання та питання захисту даних. Підрозділи покривають решту компанії."
      }
    ]
  },
  "operate": {
    "title": "Впровадження та експлуатація",
    "cards": [
      {
        "title": "Локально або у власній хмарі",
        "text": "Заздалегідь ми разом рахуємо, які процеси окупляться: рентабельність інвестицій і загальні витрати лежать на столі. Працює все на вашому апаратному забезпеченні або у вашій власній хмарі, і жоден документ не покидає ваших стін."
      },
      {
        "title": "У нас",
        "text": "pAIoneer Labs GmbH від самого початку збудована саме так: наші проєкти, наші корпоративні знання й наше адміністрування працюють на Veridion. Організація сама розробляє [трейдинг-асистента](finance) нашої платформи і є ШІ в його чаті."
      }
    ]
  },
  "cta": {
    "title": "Запит",
    "subtitle": "Як серверне програмне забезпечення у вашій інфраструктурі. Ціну повідомляємо на запит.",
    "button": "Надіслати запит",
    "subject": "Veridion Agentic Company Intelligence"
  }
};
